(function () {
  'use strict';

  function initContainer(container) {
    var link = container.querySelector('.product-description__read-more');
    if (!link) return;

    var userExpanded = false;

    // Set background inline so the CSS variable resolves correctly
    var bg = getComputedStyle(container).getPropertyValue('--desc-read-more-bg').trim() || 'white';
    link.style.background = bg;
    link.style.setProperty('--desc-read-more-bg', bg);

    link.addEventListener('click', function (e) {
      e.preventDefault();
      userExpanded = true;
      container.classList.remove('needs-read-more');
      container.classList.add('is-expanded');
    });

    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        userExpanded = true;
        container.classList.remove('needs-read-more');
        container.classList.add('is-expanded');
      }
    });

    function updateButton() {
      if (userExpanded) return;
      var isTruncated = container.scrollHeight > container.clientHeight + 2;
      container.classList.toggle('needs-read-more', isTruncated);
    }

    updateButton();

    var resizeTimer;
    window.addEventListener('resize', function () {
      if (userExpanded) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButton, 200);
    });
  }

  function init() {
    document.querySelectorAll('[data-description-truncate]').forEach(initContainer);
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-description-truncate]').forEach(initContainer);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
